import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { rutValidate } from 'rut-helpers';
import { BalanceManualService } from 'src/app/shared/services/balance-manual.service';
import { gtpRutValidator } from 'src/app/shared/validators/rut-validator';

export interface InputModel {
  data: {dataSource: {rut: string}[] ,ruts: string[], pagina: number, totalElementos: number, elementosPorPagina: number} | any;
  filtros: any;
  apiReporte: string;
}

@Component({
  selector: 'app-ruts-paginados',
  templateUrl: './ruts-paginados.component.html',
  styleUrls: ['./ruts-paginados.component.scss']
})
export class RutsPaginadosComponent implements AfterViewInit {
  public dataSource: MatTableDataSource<{value: string}> = new MatTableDataSource<{value: string}>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  public formulario!: UntypedFormGroup;
  public showTable: boolean = true;

  public totalItems: number = 0;
  public pageSize: number | null = null;
  public pageIndex: number = 0;

  inputModel: InputModel = {
    data: {
      dataSource: [],
      ruts: [],
      pagina: 1,
      totalElementos: 0,
      elementosPorPagina: 20
    },
    filtros: null,
    apiReporte: ''
  };

  public showSpinner: boolean = false;
  public messages: { text: string, isError: boolean, isSuccess: boolean }[] = [];

  constructor(public dialogRef: MatDialogRef<RutsPaginadosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputModel, 
      private formBuilder: UntypedFormBuilder,
      private balanceManualService: BalanceManualService
    ) {

    this.formulario = this.formBuilder.group({
      rut: ['', [Validators.required, gtpRutValidator()]],
    });
    
    this.inputModel = data;
    this.totalItems = this.inputModel?.data?.totalElementos || 0;
    this.pageSize = this.inputModel?.data?.elementosPorPagina || 20;
    this.pageIndex = this.inputModel?.data?.pagina - 1 || 0;
    this.generateTable();
  }

  ngAfterViewInit(): void {
  }

  generateTable(): void {
    if(this.inputModel?.data) {
      this.dataSource = new MatTableDataSource(this.inputModel?.data?.dataSource || []);
      this.dataSource.paginator = this.paginator;
    }
  }

  addMessage(mensaje: string, isError: boolean, isSuccess: boolean) : void {
    this.messages.push({ text: mensaje, isError: isError, isSuccess: isSuccess });
  }

  removeMessage(index: number) {
    this.messages.splice(index, 1);
  }

  close() {
    this.dialogRef.close(false);
  }

  handlePageEvent(event: any): void {
    const pagina = event.pageIndex + 1; // pageIndex is zero-based
    const tamanoPagina = event.pageSize; // pageSize is the number of items per page
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    if(this.inputModel?.apiReporte == 'comparativo-balances-empresa') {
      this.llamadaApiComparativo(pagina, tamanoPagina);
    }
  }

  llamadaApiComparativo(pagina: number, tamanoPagina: number): void {
    this.showSpinner = true;
    this.balanceManualService.obtenerRuts(this.inputModel?.filtros, pagina, tamanoPagina)
    .subscribe(
      (response: any) => {
        if(response?.ruts && response?.ruts.length > 0) {
          const nuevaData = response?.ruts.map((item: any) => ({ rut: item }));
          this.totalItems = response?.totalElementos;
          this.pageSize = response?.elementosPorPagina;
          this.pageIndex = Number(response?.pagina) - 1;
          this.dataSource = new MatTableDataSource(nuevaData);
          this.dataSource.paginator = this.paginator;
        } else {
          this.addMessage("El listado de ruts se encuentra vacio", true, false);
        }
        this.showSpinner = false;
      },
      ({ error }) => {
        this.addMessage(error?.message || "Ocurrio un error al intentar obtener la lista de ruts", true, false);
        this.showSpinner = false;
      }
    )
  }

  seleccionarRut(rut: string): void {
    if(!rut) {
      return;
    }
    const rutLimpio = rut.replace(/[^0-9kK]/g, '').toUpperCase();
    if(rutLimpio && rutValidate(rutLimpio)) {
      const rutConGuion = rutLimpio.slice(0, -1) + '-' + rutLimpio.slice(-1);
      this.dialogRef.close({rut: rutConGuion});
    }
  }

  enviarRut(): void {
    if(!this.formulario.valid) {
      this.addMessage('El RUT ingresado no es válido', true, false);
      return;
    }
    const rutLimpio = this.formulario.get('rut')?.value.replace(/[^0-9kK]/g, '').toUpperCase();
    if(rutLimpio && rutValidate(rutLimpio)) {
      const rutConGuion = rutLimpio.slice(0, -1) + '-' + rutLimpio.slice(-1);

      if(this.inputModel?.apiReporte == 'comparativo-balances-empresa') {
        this.showSpinner = true;
        this.balanceManualService.obtenerComparacionEmpresa(rutConGuion, this.inputModel?.filtros)
        .subscribe(
          (response: any) => {
            this.addMessage(`Rut válido y seleccionado, espere un momento...`, false, true);
            setTimeout(() => {
              this.dialogRef.close({rut: rutConGuion, response});
            }, 3000);
          },
          ({ error }) => {
            this.addMessage(error?.message || "Ocurrio un problema al intentar obtener el comparativo por empresa.", true, false);
            this.showTable = true;
            this.showSpinner = false;
          }
        )
      }
    } else {
      this.addMessage('El RUT ingresado no es válido', true, false);
    }
  }

}
